import { useState, React } from 'react';
import { TableHead, TablePagination, Button, Modal, Box, Typography , IconButton, TextField } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import axios from 'axios';
import CloseIcon from "@mui/icons-material/Close";
import Loader from '../../../../components/Loader';
import ViewPDFTaxFile from './ViewPDFTaxFile';
import { toast } from 'react-toastify';


export default function TaxSummary({ setTaxFileDataSummary, taxFileDataSummary, totalCountSummary }) {
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [page, setPage] = useState(0);
  const [orderBy, setOrderBy] = useState('createdDate');
  const [isUndoTaxFile, setIsUndoTaxFile] = useState(false);
  const [taxfreeReport, setTaxfreeReport] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [userData, setUserData] = useState([]);
  const [isUserDataModalOpen, setIsUserDataModalOpen] = useState(false);
  const [selectedBookkeepingName, setSelectedBookkeepingName] = useState("");
  const [selectedDate, setSelectedDate] = useState(""); 
  const [fileData, setFileData] = useState([]);
  const [isFileModalOpen, setIsFileModalOpen] = useState(false);
  const [loadingButtons, setLoadingButtons] = useState({});
  const [order, setOrder] = useState('desc');
  const TABLE_HEAD_SUMMARY = [
    { id: 'month', label: 'Date', alignRight: false },
    { id: 'articleNo', label: 'Article No.', alignRight: false },
    { id: 'bookkeepingName', label: 'Bookkeeping Name', alignRight: false },
    { id: 'bookkeepingCode', label: 'Bookkeeping Code', alignRight: false },
    { id: 'amount', label: 'Amount', alignRight: false },
  ];

  function applySortFilter(array, comparator) {
    const stabilizedThis = array?.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis?.map((el) => el[0]);
  }

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
    const filteredRows = applySortFilter(
      taxFileDataSummary,
      getComparator(isAsc ? 'desc' : 'asc', orderBy),
      event.target.value,
      taxFileDataSummary
    );
    setTaxFileDataSummary(filteredRows);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const getMonthName = (month) => {
    return new Date(0, month - 1).toLocaleString("en-US", { month: "long" });
  };

const handleViewDetails = async (invoiceNumber, userId, articleNumber,amount) => {
  const key = `${invoiceNumber}-${userId}-${articleNumber}-${amount}`; // Create a unique key for the button
  if (loadingButtons[key]) return; 

  setLoadingButtons((prev) => ({ ...prev, [key]: true })); // Set loading state for this button

  try {
      const response = await axios.get(`taxfree/details?invoiceNumber=${invoiceNumber}&userId=${userId}&articleNumber=${articleNumber}&amount=${amount}`);
      const fileDataResponse = response.data.response || [];

      if (fileDataResponse.length === 0) {
          toast.error('No file data available for the given invoice number.');
          setFileData([]);
      } else {
          setFileData(fileDataResponse);
      }

      setIsFileModalOpen(true);
  } catch (error) {
      if (error.response?.status === 404) {
          toast.error('PDF not found for this invoice.');
      } else if (error.response?.status === 500) {
          toast.error(error.response.data.message || 'Internal server error. Please try again later.');
      } else {
          console.error('Error fetching file data:', error);
          toast.error('An error occurred while fetching file data.');
      }
  } finally {
      setLoadingButtons((prev) => ({ ...prev, [key]: false })); // Reset loading state
  }
};
  const handleAmountClick = async (articleNumber, month, year,  bookkeepingName) => {
    if (loading) return;
    
    setSelectedBookkeepingName(bookkeepingName);
    setLoading(true);
    setTaxfreeReport([]);

    try {
        const selectedArticle = { articleNumber, month, year };
        const result = await axios.post('/taxfree/taxfee-report', selectedArticle);
        const responseArray = result.data.response || [];

        setTaxfreeReport(responseArray);
        setIsUserDataModalOpen(true);
        
    } catch (error) {
        console.error('Error fetching tax report:', error);
    } finally {
        setLoading(false); 
    }
};

const hasArticle138 = taxfreeReport.some(({ salaryDetails }) =>
  salaryDetails?.some(detail => detail.articleNumber === 138 || detail.articleNumber === "138")
);

  return (
    <>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="summary table">
          <TableHead>
            <TableRow>
              {TABLE_HEAD_SUMMARY.map((headCell) => (
                <TableCell key={headCell.id} align={headCell.alignRight ? 'right' : 'left'}>
                  {headCell.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {taxFileDataSummary.length > 0 ? (
              taxFileDataSummary.flatMap(({ year, month, totals = [] }) =>
                totals.map(({ taxType, bookkeepingCode, bookkeepingName, amount }, idx) => (
                  <TableRow key={`${taxType}-${year}-${month}-${idx}`}>
                    <TableCell>{getMonthName(month)}-{year}</TableCell>
                    <TableCell>{taxType}</TableCell>
                    <TableCell>{bookkeepingName}</TableCell>
                    <TableCell>{bookkeepingCode}</TableCell>
                    <TableCell>
                      <Button onClick={() => handleAmountClick(taxType, month, year, bookkeepingName)}>
                        {amount?.toFixed(2) ?? "0.00"}
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              )
            ) : (
              <TableRow>
                <TableCell colSpan={6} style={{ textAlign: 'center' }}>
                  No Data Available
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>

      </TableContainer>

      <ViewPDFTaxFile
      isFileModalOpen={isFileModalOpen} setIsFileModalOpen={setIsFileModalOpen} fileData={fileData}/>
      
      {loading && <Loader />}

      <Modal
  open={isUserDataModalOpen}
  onClose={() => setIsUserDataModalOpen(false)}
  aria-labelledby="user-data-modal-title"
  aria-describedby="user-data-modal-description"
>
  <Box
    sx={{
      padding: 3,
      backgroundColor: "white",
      margin: "auto",
      top: "50%",
      position: "absolute",
      left: "50%",
      transform: "translate(-50%, -50%)",
      overflow: "hidden",
      height: "auto",
      maxHeight: "80vh",
      width: "90vw",
      maxWidth: "700px",
      borderRadius: "10px",
      boxShadow: 3,
      display: "flex",
      flexDirection: "column",
    }}
  >
    {/* Close Button */}
    <IconButton
      onClick={() => setIsUserDataModalOpen(false)}
      sx={{
        position: "absolute",
        top: 10,
        right: 10,
        color: "black",
        backgroundColor: "#f5f5f5",
        "&:hover": {
          backgroundColor: "#e0e0e0",
        },
      }}
    >
      <CloseIcon />
    </IconButton>

    {/* Title */}
    <Typography id="user-data-modal-title" variant="h6" component="h2" sx={{ textAlign: "center", mb: 2 }}>
      {selectedBookkeepingName || "User Data"}
    </Typography>

    {/* Responsive Table */}
    <TableContainer component={Paper} sx={{ overflowX: "auto", maxHeight: "60vh" }}>
      <Table sx={{ minWidth: 650 }} aria-label="user data table" stickyHeader>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
            <TableCell><strong>Date</strong></TableCell>
            <TableCell><strong>User ID</strong></TableCell>
            <TableCell><strong>Name</strong></TableCell>
            <TableCell><strong>Amount</strong></TableCell>
            {!hasArticle138 && (
            <TableCell><strong>View Details</strong></TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          <>
          {taxfreeReport.length > 0 ? (
            taxfreeReport.flatMap(({ year, month, salaryDetails }) =>
              salaryDetails.map(({ userId, firstName, lastName, amount, invoiceNumber, articleNumber}) => (
                <TableRow key={`${userId}-${month}-${year}`}>
                  <TableCell>{`${getMonthName(month)}-${year}`}</TableCell>
                  <TableCell>{userId}</TableCell>
                  <TableCell>{`${firstName} ${lastName}`}</TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#1976d2" }}>
                    {amount.toFixed(2)}
                  </TableCell>
                  {!hasArticle138 && (
                  <TableCell>
                  {loadingButtons[`${invoiceNumber}-${userId}-${articleNumber}-${amount}`] ? (
                     "Loading..."
                    ) : (
                    <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleViewDetails(invoiceNumber, userId, articleNumber, amount)}
                    disabled={loadingButtons[`${invoiceNumber}-${userId}-${articleNumber}-${amount}`]} 
                    >
                      View 
                    </Button>)}
                    </TableCell>
                  )}
                </TableRow>
              ))
            )
          ) : (
            <TableRow>
              <TableCell colSpan={4} align="center">
                No User Data Available
              </TableCell>
            </TableRow>
          )}</>
        </TableBody>
      </Table>
    </TableContainer>
  </Box>
</Modal>

    </>
  );
}
